/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Constants for SettingsPositions component
 *
 * @author Aleksandr Perkhunov
 * @version 1.3.0
 * @since 1.3.0
 */

export const GET_SETTINGS_POSITIONS_LIST_ACTION = '@@b2b_portal_ui/settingsLabels/GET_SETTINGS_POSITIONS_LIST_ACTION';
export const GET_SETTINGS_POSITIONS_LIST_SUCCESS = '@@b2b_portal_ui/settingsLabels/GET_SETTINGS_POSITIONS_LIST_SUCCESS';
export const GET_SETTINGS_POSITIONS_LIST_FAILURE = '@@b2b_portal_ui/settingsLabels/GET_SETTINGS_POSITIONS_LIST_FAILURE';

export const ADD_SETTINGS_POSITION_ACTION = '@@b2b_portal_ui/settingsLabels/ADD_SETTINGS_POSITION_ACTION';
export const ADD_SETTINGS_POSITION_SUCCESS = '@@b2b_portal_ui/settingsLabels/ADD_SETTINGS_POSITION_SUCCESS';
export const ADD_SETTINGS_POSITION_FAILURE = '@@b2b_portal_ui/settingsLabels/ADD_SETTINGS_POSITION_FAILURE';

export const REMOVE_SETTINGS_POSITION_ACTION = '@@b2b_portal_ui/settingsLabels/REMOVE_SETTINGS_POSITION_ACTION';
export const REMOVE_SETTINGS_POSITION_SUCCESS = '@@b2b_portal_ui/settingsLabels/REMOVE_SETTINGS_POSITION_SUCCESS';
export const REMOVE_SETTINGS_POSITION_FAILURE = '@@b2b_portal_ui/settingsLabels/REMOVE_SETTINGS_POSITION_FAILURE';
